import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {AUTH_TOKEN} from "../../../constants/AuthConstant";
import dokumenService from "../../../services/ref/dokumenService";
import Cookies from "js-cookie";

export const initialState = {
    loading_dokumen: false,
    data_dokumen: [],
    showMessage: false,
    message: '',
}

export const getDataDokumen = createAsyncThunk('dokumen/data', async (data, { rejectWithValue }) => {
    try {
        const response = await dokumenService.data(Cookies.get(AUTH_TOKEN), data)
        return response
    } catch (err) {
        // Handle error
    }
})

export const dokumenSlice = createSlice({
    name: 'dokumen',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_dokumen = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataDokumen.fulfilled, (state, action) => {
                state.loading_dokumen = false
                state.data_dokumen = action.payload ?? []
            })
            .addCase(getDataDokumen.pending, (state) => {
                state.loading_dokumen = true
            })
            .addCase(getDataDokumen.rejected, (state, action) => {
                state.loading_dokumen = false
                state.data_dokumen = action.payload
            })
    },
})

export const {
    showLoading,
} = dokumenSlice.actions

export default dokumenSlice.reducer
